import SectionIndex from '../../views/Admin/Config/Section/SectionIndex';
import SectionEdit from '../../views/Admin/Config/Section/SectionEdit';
import SectionCreate from '../../views/Admin/Config/Section/SectionCreate';
import LayoutPrimary from '../../layouts/Primary';

export default [
    {
        path: '/section/create',
        name: 'SectionCreate',
        component: SectionCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/section/index',
        name: 'SectionIndex',
        component: SectionIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/section/edit/:id',
        name: 'SectionEdit',
        component: SectionEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
